// Writes to /Knowledge/* (save, create, lock). The custom header is the controller's CSRF guard; the reply is the
// Hub's JSON, with { error } on a refusal (403 can't edit, 409 conflict, 422 secret found, 423 being edited...).

export interface KnowledgeReply<T> {
    status: number;
    data: T & { error?: string };
}

export const sendJson = async <T,>(url: string, method: 'POST' | 'PUT', body?: object): Promise<KnowledgeReply<T>> => {
    const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Knowledge-App': '1' },
        body: body === undefined ? undefined : JSON.stringify(body)
    });
    const type = response.headers.get('content-type') ?? '';
    if (response.redirected || (response.ok && response.status !== 204 && !type.includes('json'))) {
        return { status: 401, data: { error: 'Your session has ended. Reload the page to sign in again.' } as T & { error?: string } };
    }
    let data = {} as T & { error?: string };
    if (type.includes('json')) {
        data = await response.json();
    }
    else if (!response.ok) {
        data = { error: (await response.text()) || response.statusText } as T & { error?: string };
    }
    return { status: response.status, data };
};
